import {IMAGE_URL} from "../../../path";
import {Link} from "react-router-dom";
import {useState} from "react";
import Header from "../Header";

type Recipe = {
    id: number;
    name: string;
    slug: string;
    cover_image: string;
};

type RecipeWizardHeaderProps = {
    wizardRecipes: Recipe[];
};

function RecipeWizardHeader({wizardRecipes,}: RecipeWizardHeaderProps) {
    const [selectedRecipe, setSelectedRecipe] =
        useState(wizardRecipes[0]);

    function previousSlide() {
        const currentIndex = wizardRecipes.findIndex(
            (r: any) => r.id === selectedRecipe.id
        );

        const previousIndex =
            currentIndex === 0
                ? wizardRecipes.length - 1
                : currentIndex - 1;

        setSelectedRecipe(
            wizardRecipes[previousIndex]
        );
    }

    function nextSlide() {
        const currentIndex = wizardRecipes.findIndex(
            (r: any) => r.id === selectedRecipe.id
        );

        const nextIndex =
            currentIndex === wizardRecipes.length - 1
                ? 0
                : currentIndex + 1;

        setSelectedRecipe(
            wizardRecipes[nextIndex]
        );
    }

    return <div
        className="product-hero-section"
        style={{
            backgroundImage: `url(${IMAGE_URL}${selectedRecipe.cover_image})`,
        }}
    >
        <Header />

        <div className="wizard-section-inner">
            <h1>{selectedRecipe.name}</h1>
        </div>


        <div className="product-actions">
            <div className="product-start-cooking-button">
                <Link
                    className="nav-cooking"
                    to={`/recipe/${selectedRecipe.slug}`}
                    state={{
                        wizardRecipes,
                    }}
                >
                    Start Cooking
                </Link>
            </div>

            <div className="product-nav-buttons">
                {wizardRecipes.length > 1 && (
                    <div className="gallery-navigation">
                        <div onClick={previousSlide}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                <g id="Group_918" data-name="Group 918" transform="translate(-792 -942)">
                                    <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" transform="translate(792 942)" fill="#436ab3"/>
                                    <path id="Path_14050" data-name="Path 14050" d="M13.25,4.5l-5,5,5,5" transform="translate(792.75 945)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </g>
                            </svg>
                        </div>

                        {wizardRecipes.map((item: any) => (
                            <div
                                key={item.id}
                                className={`navigation-dot ${
                                    item.id === selectedRecipe.id
                                        ? "active"
                                        : ""
                                }`}
                                onClick={() => setSelectedRecipe(item)}
                            />
                        ))}

                        <div onClick={nextSlide}>
                            <svg id="Group_917" data-name="Group 917" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" fill="#436ab3"/>
                                <path id="Path_14050" data-name="Path 14050" d="M8.25,4.5l5,5-5,5" transform="translate(2.75 3)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                            </svg>

                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>
}

export default RecipeWizardHeader;
